import * as React from 'react';

import { WrappedFC } from '../shared/types';

export type ButtonType =
  | 'nextButton'
  | 'loginButton'
  | 'detailButton'
  | 'toolButton'
  | 'countryButton'
  | 'languageButton'
  | 'cancelButton'
  | 'showLinkButton'
  | 'registerButton'
  | 'uploadButton'
  | 'downloadButton'
  | 'deviceButton'
  | 'deleteButton'
  | 'cancelButton'
  | 'okButton'
  | 'filterClearButton'
  | 'selectButton';
export type SubButtonType =
  | 'default'
  | 'small'
  | 'close'
  | 'user'
  | 'menu'
  | 'home'
  | 'highPriority'
  | 'invalid'
  | 'checkOn'
  | 'checkOff';

interface Props {
  /** 表示するコンポーネントの種類 */
  type: ButtonType;
  /** サブタイプ */
  subType?: SubButtonType;
  /** クリック時のCallback */
  onClick?: (e: React.MouseEvent) => void;
}

const DEFAULT_COMPONENT: keyof JSX.IntrinsicElements = 'div';

/**
 * ボタンコンポーネント
 */
export const Button: WrappedFC<typeof DEFAULT_COMPONENT, Props> = ({
  type,
  subType = 'default',
  className,
  element: Element = DEFAULT_COMPONENT,
  ...props
}) => {
  const _type = subType === 'default' ? type : `${type} ${subType}`;
  const _clsName = className || _type;
  return (
    <Element {...props} className={_clsName}>
      {props.children}
    </Element>
  );
};
Button.displayName = 'Button';
